import classNames from 'classnames';
import styles from './SkipToMain.module.scss';

export interface SkipToMainProps {
	children: React.ReactNode;
	link?: string;
	title?: string;
}

export const SkipToMain: React.FC<SkipToMainProps> = ({ children, title, link }) => (
	<a href={link} title={title} className={classNames(styles.SkipToMain)}>
		{children}
	</a>
);
